import { Button } from '@chakra-ui/react'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'

import useDocumentTemplate from '../useDocumentTemplate'

const PDF_MIME_TYPE = 'application/pdf'

const readErrorMessage = async (err) => {
  const fallback = err?.response?.data?.message || err?.message || 'Failed to generate template preview'

  if (!(err?.response?.data instanceof Blob)) {
    return fallback
  }

  const blobText = await err.response.data.text()

  try {
    return JSON.parse(blobText)?.message || fallback
  } catch {
    return blobText || fallback
  }
}

const readFileName = (response, fallback) => {
  const contentDisposition = response.headers['content-disposition']

  if (contentDisposition && contentDisposition.includes('filename=')) {
    return contentDisposition.split('filename=')[1].replace(/"/g, '')
  }

  return fallback
}

const DocumentTemplatePreviewButton = ({ templateId, signed = false, children }) => {
  const { usePreviewDocumentTemplate } = useDocumentTemplate()
  const previewDocumentTemplate = usePreviewDocumentTemplate()

  const handlePreview = async () => {
    // Opened synchronously with the click: a tab opened only after the merge
    // returns is no longer a user gesture, and popup blockers would stop it.
    const previewTab = window.open('', '_blank')

    try {
      const response = await previewDocumentTemplate.mutateAsync({ id: templateId, signed })
      const contentType = response.headers['content-type'] ?? ''
      const blob = new Blob([response.data], { type: contentType })

      if (contentType.includes(PDF_MIME_TYPE) && previewTab) {
        previewTab.location.href = URL.createObjectURL(blob)
        return
      }

      // Not a PDF (the server could not convert it), or the tab was blocked anyway.
      previewTab?.close()
      saveAs(blob, readFileName(response, 'template-preview'))
    } catch (err) {
      previewTab?.close()
      toast.error(await readErrorMessage(err))
    }
  }

  return (
    <Button
      colorScheme="blue"
      variant="outline"
      isLoading={previewDocumentTemplate.isPending}
      onClick={(e) => {
        e.stopPropagation()

        handlePreview()
      }}
    >
      {children}
    </Button>
  )
}

export default DocumentTemplatePreviewButton
